<script setup lang="ts">
import type { Hub } from '@/data/Hubs/types'
import { useAllHubsListQuery } from '@/data/Hubs/useAllHubsListQuery'
import HubsList from '@/modules/Workspaces/KnowledgeHub/Hubs/HubsList.vue'
import HubsListEmptyState from '@/modules/Workspaces/KnowledgeHub/Hubs/HubsListEmptyState.vue'
import PageContainer from '@/modules/Workspaces/KnowledgeHub/Layout/PageContainer.vue'
import PageTitle from '@/modules/Workspaces/KnowledgeHub/Layout/PageTitle.vue'
import PageTitleBar from '@/modules/Workspaces/KnowledgeHub/Layout/PageTitleBar.vue'
import { useWorkspaceContext } from '@/modules/Workspaces/useWorkspaceContext'
import { computed } from 'vue'

const { workspaceId } = useWorkspaceContext()
const { data, isFetched } = useAllHubsListQuery({ workspaceId })

/** Hubs sorted so that most recently updated hubs are at the top */
const recentHubs = computed<Hub[]>(() => {
  const values: Hub[] = Array.from(data.value?.values() || [])
  return values.sort((a, b) => b.createdAt.localeCompare(a.createdAt))
})

const hasNoHubs = computed(() => isFetched.value && recentHubs.value.length === 0)
</script>

<template>
  <PageContainer
    class="test"
    :class="{ 'flex min-h-full flex-col pb-10': hasNoHubs }"
  >
    <PageTitleBar
      v-if="isFetched && recentHubs.length > 0"
      class="mb-10"
    >
      <template #title>
        <PageTitle>Hubs</PageTitle>
      </template>
    </PageTitleBar>

    <div
      v-if="hasNoHubs"
      class="flex flex-1 items-center justify-center"
    >
      <HubsListEmptyState />
    </div>

    <HubsList
      v-else-if="isFetched && recentHubs.length > 0"
      :hubs="recentHubs"
    />
  </PageContainer>
</template>
